var React = require('react');

function NotEqual (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M35.59 466.83a16 16 0 0 0 3 22.42L64 508.75a16 16 0 0 0 22.43-3L168.52 400h-81zM162 304h81l74.51-96h-81zM441 22.78L415.61 3.29a16 16 0 0 0-22.43 3L311.11 112h81L444 45.21a16 16 0 0 0-3-22.43z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M416 304H32a32 32 0 0 0-32 32v32a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32v-32a32 32 0 0 0-32-32zm0-192H32a32 32 0 0 0-32 32v32a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32v-32a32 32 0 0 0-32-32z","className":"fa-primary","key":2})]);
}

NotEqual.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = NotEqual;

NotEqual.default = NotEqual;
